module.exports = __webpack_public_path__ + "counter-arrow.f5a6e6ecd140f296d71fb0ac0ae69cf6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/counter-arrow.svg
// module id = 1133
// module chunks = 0